<template>
  <div id="candidatos-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos Evaluación</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- DATOS DE EVALUACION  -->
                    <data-evaluacion
                      :id="id"
                      :tipeView="tipeView"
                    ></data-evaluacion>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataEvaluacion from "@/modules/aplicacion/views/seleccion/evaluacion/EvaluacionData.vue";
import axios from "axios";

export default {
  name: "evaluacion-registra",

  components: {
    DataEvaluacion,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      documentoId: "",
      id: "",
      tipeView: "",
    };
  },

  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
